export default function pathToIndex(path: number[]): number {
    const index = Math.floor(
        (path.reduce((acc, v) => acc + (v ? 1 : -1), 0) + path.length) / 2,
    );

    return index;
}
